import { FC, useEffect, useState } from "react";
import { PlacementDoc } from "../../../models/placements";
import { Tender } from "../../../models/tendering";
import { Dialog, DialogSurface, Title2, Title3, Text, DialogContent, Subtitle1, DialogActions, Button, Spinner } from "@fluentui/react-components";
import { updatePlacement } from "../../../services/placementService";
import { useAppContext } from "../../../AppContext";

interface ContactTenderProps{
    isOpen:boolean;
    onClose: () => void;
    tender: Tender;
    placement:PlacementDoc;
    placementDocID: string;
    onPlacementUpdate?: (updatedPlacement: PlacementDoc) => void;
}

export const ContactTender: FC<ContactTenderProps> = ({
  isOpen,
  onClose,
  tender,
  placement,
  placementDocID,
  onPlacementUpdate
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const {user} = useAppContext();

  const acceptTender = async () => {
    setIsUpdating(true);
    try {
      // Create a deep copy with updated values
      const updatedTenders = [...placement.tenders];
      const pickedTender = updatedTenders.find(t => t.tenderID === tender.tenderID);

      pickedTender.accepted = true;
      
      const updatedPlacement: PlacementDoc = {
        ...placement,
        logs: {
          ...placement.logs,
          tenderPicked: {
            date: new Date().toISOString(),
            user: user.user.firstName + " " + user.user.lastName 
          }
        },
        tenders: updatedTenders,
        status: "accepted"
      };
      
      await updatePlacement(updatedPlacement, placementDocID);
      
      // Update the parent component's placement state
      if (onPlacementUpdate) {
        onPlacementUpdate(updatedPlacement);
      }
      
      onClose();
    } catch (error) {
      console.error('Error updating placement:', error);
      // Handle error as needed
    } finally {
      setIsUpdating(false);
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={(event, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogContent className="flex flex-col gap-2">
            <Subtitle1>Kontakta verksamhet</Subtitle1>
            <Text>Du behöver först kontakta verksamheten innan du kan välja den. När ni har kommit överens kan du klicka på "Välj verksamhet" för att slutföra förfrågningsprocessen och få tillgång till avtal, loggar och annan information.</Text>
            <div className="flex flex-col mt-4">
              <Text weight="semibold">Förfrågan ID: <Text>{placement.reference}</Text></Text>
              <Text weight="semibold">Leverantör: <Text>{tender.tenderName}</Text></Text>
              <Text weight="semibold">E-post: <Text>{tender.contact?.email}</Text></Text>
              <Text weight="semibold">Telefon: <Text>{tender.contact?.phone}</Text></Text>
            </div>
        </DialogContent>
        <DialogActions className="mt-8">
            <Button onClick={onClose} disabled={isUpdating}>Avbryt</Button>
            <Button 
              appearance="primary" 
              onClick={acceptTender}
              disabled={isUpdating}
            >
              {isUpdating ? (
                <>
                  <Spinner size="tiny" className="mr-2" />
                  Uppdaterar...
                </>
              ) : (
                'Välj verksamhet'
              )}
            </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};

export default ContactTender;